var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.083 24C12.2677 24 12.4519 23.9953 12.6347 23.9868H12.7069V23.9835C15.7491 23.8258 18.4898 22.5184 20.5092 20.485C22.6659 18.3133 24 15.3128 24 11.9998C24 8.68677 22.6659 5.68671 20.5092 3.51502C18.4898 1.48162 15.7486 0.17417 12.7069 0.0160481V0.0127441H12.6347C12.4519 0.00424804 12.2677 0 12.083 0L11.9208 0.000944009L11.917 0C8.62687 0 5.6475 1.34332 3.49078 3.51502C1.33453 5.68671 0 8.68677 0 11.9998C0 15.3128 1.33453 18.3133 3.49078 20.485C5.6475 22.6567 8.62687 24 11.917 24L11.9208 23.9986L12.083 24ZM12.7069 22.5576V1.44245C15.3595 1.59868 17.7469 2.74565 19.5098 4.52133C21.4106 6.43483 22.5858 9.079 22.5858 11.9998C22.5858 14.921 21.4106 17.5652 19.5098 19.4787C17.7469 21.2539 15.3595 22.4009 12.7069 22.5576Z",
    fill: "#B99750"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBackground);
export default __webpack_public_path__ + "static/media/check-background.18ac5944fd0d91c2ad0f29b953a5fe58.svg";
export { ForwardRef as ReactComponent };